import React from 'react';
import { Sparkles } from 'lucide-react';

const Hero = () => {
  return (
    <section className="relative min-h-screen flex items-center justify-center px-6 py-20 bg-gradient-to-br from-cream-50 via-cream-100 to-sage-50">
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-20 left-10 w-72 h-72 bg-sage-300 rounded-full mix-blend-multiply filter blur-3xl animate-pulse"></div>
        <div className="absolute bottom-20 right-10 w-96 h-96 bg-terracotta-200 rounded-full mix-blend-multiply filter blur-3xl animate-pulse delay-700"></div>
      </div>
      
      <div className="relative max-w-5xl mx-auto text-center">
        <div className="inline-flex items-center gap-2 px-4 py-2 bg-white/60 backdrop-blur-sm rounded-full border border-sage-200 mb-8">
          <Sparkles className="w-4 h-4 text-sage-600" />
          <span className="text-sm font-medium text-sage-700">Powered by AI</span>
        </div>
        
        <h1 className="font-serif text-5xl md:text-7xl font-bold text-gray-900 mb-6 leading-tight">
          Wisuda Lebih Tertib,<br />
          <span className="text-sage-600">Informatif</span>, dan{' '}
          <span className="text-terracotta-500">Berkesan</span>
        </h1>
        
        <p className="text-xl md:text-2xl text-gray-700 mb-10 max-w-3xl mx-auto leading-relaxed">
          Layanan AI berbasis WhatsApp yang membantu kampus menyampaikan informasi wisuda secara terpusat 
          sekaligus mengumpulkan kenangan digital wisudawan—tanpa mengganggu marwah akademik.
        </p>
        
        <button className="group px-8 py-4 bg-sage-600 hover:bg-sage-700 text-white font-semibold rounded-full transition-all duration-300 shadow-lg hover:shadow-xl transform hover:-translate-y-1">
          <span className="flex items-center gap-2">
            Coba Demo
            <svg className="w-5 h-5 group-hover:translate-x-1 transition-transform" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 8l4 4m0 0l-4 4m4-4H3" />
            </svg>
          </span>
        </button>
        
        <p className="mt-6 text-sm text-gray-600">
          Rasakan langsung bagaimana Wisuda.ai bekerja sebagai AI Agent resmi acara wisuda
        </p>
      </div>
    </section>
  );
};

export default Hero;
